import TaxCalculator from "./TaxCalculator";

function App() {
  return <TaxCalculator />;
}

export default App;
